module.exports = __webpack_public_path__ + "static/media/Networking.0d4f712a.png";